// src/utils/arPresentFormII_salim.js
// בניין 2 (يُفَعِّلُ) - נטיות הווה-עתיד לגזרת השלמים

const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';
const HARAKAT_RE = /[\u064B-\u065F]/g;

const stripHarakat = s => (s || '').replace(HARAKAT_RE, '');
const onlyArabicLetters = s => (s || '').replace(/[^\u0621-\u064A]/g, '');

function getRadicalsFromVerb3ms(verb3ms) {
  const base = onlyArabicLetters(stripHarakat(verb3ms));
  if (base.length !== 3) return null;
  return [base[0], base[1], base[2]];
}

export function conjugatePresentFormII_Salim(verb3ms) {
  if (!verb3ms) return null;

  const R = getRadicalsFromVerb3ms(verb3ms);
  if (!R) return null;

  const [R1, R2, R3] = R;
  const isNunEnding = R3 === 'ن';

  const stem = R1 + FATHA + R2 + SHADDA + KASRA + R3;

  return {
    'أَنَا'    : 'أ' + DAMMA + stem + DAMMA,
    'أَنْتَ'   : 'ت' + DAMMA + stem + DAMMA,
    'أَنْتِ'   : 'ت' + DAMMA + stem + KASRA + 'ي' + 'نَ',
    'هُوَ'     : 'ي' + DAMMA + stem + DAMMA,
    'هِيَ'     : 'ت' + DAMMA + stem + DAMMA,
    'نَحْنُ'   : 'ن' + DAMMA + stem + DAMMA,
    'أَنْتُمْ' : 'ت' + DAMMA + stem + DAMMA + 'و' + 'نَ',
    'أَنْتُنَّ': isNunEnding ? 'ت' + DAMMA + stem + SHADDA + FATHA : 'ت' + DAMMA + stem + SUKUN + 'نَ',
    'هُمْ'     : 'ي' + DAMMA + stem + DAMMA + 'و' + 'نَ',
    'هُنَّ'    : isNunEnding ? 'ي' + DAMMA + stem + SHADDA + FATHA : 'ي' + DAMMA + stem + SUKUN + 'نَ',
  };
}

export function conjugatePresentFormII_Salim_fromRow(row) {
  const binyan = (row['בניין'] || '').trim();
  const gizra = (row['gizra'] || '').trim();

  if (!(binyan === '2' || binyan === 'בניין 2')) return null;
  const gizraOk = gizra.includes('שלמים') || gizra.includes('כפולים') || gizra.includes('ע"ו') || gizra.includes('פ"ו');
  if (!gizraOk) return null;

  return conjugatePresentFormII_Salim(row['פועל']);
}
